import React from 'react';

const AddUserModal = React.lazy(() => import('../components/AddUserModal'));
const grantedUserModalRegistry = {
    core_grantedUserAdd: AddUserModal
};

export default grantedUserModalRegistry;
